import { invokeInit } from "./init";
const TSS = {};
(function () {
  function StorageClient(options) {
    console.log(this instanceof StorageClient);
    if (!this instanceof StorageClient) {
      throw new Error(
        "StorageClient is a constructor and should be called with the `new` keyword",
      );
    }
    this._init(options);
  }

  TSS.StorageClient = StorageClient;
  invokeInit(StorageClient);
})();

export default TSS;
